import { render, staticRenderFns } from "./textV1.vue?vue&type=template&id=4b20c0cb&scoped=true&"
import script from "./textV1.vue?vue&type=script&lang=js&"
export * from "./textV1.vue?vue&type=script&lang=js&"
import style0 from "./textV1.vue?vue&type=style&index=0&id=4b20c0cb&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b20c0cb",
  null
  
)

export default component.exports